export default "__VITE_PUBLIC_ASSET__ddce5db5__"